import React from "react";
import "./index.css";

function index() {
  return (
    <div class="main-div">
      <div class="headline-div">
        <h1 class="headline-cta">Listen to Thread</h1>
        <h1 class="headline-branding"> beta by Audiblogs.com</h1>
      </div>
      <div class="profile-div">
        <img
          class="profile-img"
          src="https://pbs.twimg.com/profile_images/1193617065384517633/Uayuvdhj_400x400.jpg"
        />
        <div class="profile-metadata">
          <div class="user-name">Lily Maynard</div>
          <div class="user-screen-name">@LilyLilyMaynard</div>
        </div>
      </div>

      <div class="quote">
        If you’re a bloke who honestly believes tons of slap, false boobs, a wig
        and fake nails magically make you into a woman, & that wearing t...
      </div>
    </div>
  );
}

export default index;
